import { commodityConstants } from '../../_constants';
import { commodityService } from '../../_services';
import { alertActions, confirmPromptActions, userActions } from '../index';

export const commodityActions = {
    getAllCommodityGoods,
    loadCommodityGoods,
    getCommodityGoods,
    createCommodityGoods,
    updateCommodityGoods,
    deleteCommodityGoods,
    resetCommodity,
    loadByCategory,
    readCommodityByCategory,
};

function resetCommodity() { return { type: commodityConstants.RESET } }

function commodityFetching() { return { type: commodityConstants.COMMODITY_FETCHING } }
function commodityFetched() { return { type: commodityConstants.COMMODITY_FETCHED } }

function commoditySubmitting() { return { type: commodityConstants.COMMODITY_SUBMITTING } }
function commoditySubmitted() { return { type: commodityConstants.COMMODITY_SUBMITTED } }

function loadByCategory(data){
    return dispatch => {
        dispatch(commodityFetching());
        dispatch(userActions.allowLeavePage());
        commodityService.loadByCategory(data)
            .then(
                commodities => {
                    dispatch(success(commodities));
                    dispatch(commodityFetched());
                },
                error => {
                    dispatch(commodityFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    }
    function success(commodities) { return { type: commodityConstants.COMMODITIES, commodities } }
}
function readCommodityByCategory(data){
    return dispatch => {
        dispatch(commodityFetching());
        dispatch(userActions.allowLeavePage());
        commodityService.readCommodityByCategory(data)
            .then(
                commodities => {
                    dispatch(success(commodities));
                    dispatch(commodityFetched());
                },
                error => {
                    dispatch(commodityFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    }
    function success(commodities) { return { type: commodityConstants.COMMODITIES, commodities } }
}

function getAllCommodityGoods(){
    return dispatch => {
        dispatch(commodityFetching());
        commodityService.getAllCommodityGoods()
            .then(
                commodities => {
                    dispatch(success(commodities));
                    dispatch(commodityFetched());
                },
                error => {
                    dispatch(commodityFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    }
    function success(commodities) { return { type: commodityConstants.COMMODITIES, commodities } }
}
function loadCommodityGoods(skip, take, search) {
    return dispatch => {
        dispatch(commodityFetching());
        commodityService.loadCommodityGoods(skip, take, search)
            .then(
                commodities => {
                    if (commodities.length > 0) {
                        dispatch(success(commodities));
                        dispatch(commodityFetched());
                    } else {
                        dispatch(commodityFetched());
                        dispatch(alertActions.warning('No more data to load'))
                    }
                },
                error => {
                    dispatch(commodityFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    }
    function success(commodities) { return { type: commodityConstants.COMMODITIES, commodities } }
}
function getCommodityGoods(id) {
    return dispatch => {
        dispatch(commodityFetching());
        commodityService.getCommodityGoods(id)
            .then(
                commodity => {
                    dispatch(success(commodity))
                    dispatch(commodityFetched());
                },
                error => {
                    dispatch(commodityFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    }
    function success(commodity) { return { type: commodityConstants.COMMODITY, commodity } }
}
function createCommodityGoods(payload) {
    return dispatch => {
        dispatch(commoditySubmitting());
        dispatch(userActions.notallowLeavePage());
        commodityService.createCommodityGoods(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(commoditySubmitted());
                    dispatch(alertActions.success('Commodity added successfully'))
                    if(payload.category){
                        window.location.href = '/master_data/commodity/category/' + payload.category;
                    }
                    else{
                        window.location.href = '/master_data/commodity';
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(commoditySubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function updateCommodityGoods(payload, id) {
    return dispatch => {
        dispatch(commoditySubmitting());
        dispatch(userActions.notallowLeavePage());
        commodityService.updateCommodityGoods(payload, id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(commoditySubmitted());
                    dispatch(alertActions.success('Commodity updated successfully'))
                    if(payload.category){
                        window.location.href = '/master_data/commodity/category/' + payload.category;
                    }
                    else{
                        window.location.href = '/master_data/commodity';
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(commoditySubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function deleteCommodityGoods(id, type) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        commodityService.deleteCommodityGoods(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Commodity deleted successfully'));
                    switch (type) {
                        case "specific":
                            window.location.href = '/master_data/commodity';
                            break;
                        default:
                            // switch type became category/group
                            dispatch(readCommodityByCategory(type));
                            // dispatch(loadCommodityGoods(0, 20));
                            break;
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()))
                    switch (type) {
                        case "specific":
                            window.location.href = '/master_data/commodity';
                            break;
                        default:
                            dispatch(loadCommodityGoods(0, 20));
                            break;
                    }
                }
            );
    };
}